// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3mSku","name":"ConsentHeader_name__2I__m","birthday":"ConsentHeader_birthday__CuvWN","skeleton":"ConsentHeader_skeleton__2UA_e"};